import "./Purchase.css";
import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../Auth.js";
import Button from "../components/Button";

export default function Success() {
  const { currentUser } = useContext(AuthContext);
  const navigate = useNavigate();

  const queryParameters = new URLSearchParams(window.location.search);
  const userId = queryParameters.get("user_id");

  useEffect(() => {
    if (!currentUser) {
      navigate("/login");
      return;
    }
    if (userId !== currentUser?.uid) {
      alert("user ID's not matching, please contact support");
      navigate("/account");
    }
  }, [userId, currentUser, navigate]);

  return (
    <>
      <div id="purchaseHeader">
        <div id="purchaseHeaderText">
          <h1 style={{ fontFamily: "NexaBold", fontSize: "26px" }}>
            Thank you for subscribing to Piggyback.
          </h1>
          <p className="purchaseParagraph">
            Your subscription is active, tied to {currentUser?.email}. Open your
            account page to use a seat for yourself and/or invite your team by
            email — each seat is at your plan's tier. If anything looks off
            within 2 hours, message us at reframingliteracy@gmail.com.
          </p>

          <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap" }}>
            <Button onClick={() => navigate("/account")}>
              Go to my account
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}
